import { cn } from '../../lib/utils';

const FormField = ({
  label,
  required = false,
  optional = false,
  children,
  hint = null,
  error = null,
  className
}) => (
  <div className={cn('space-y-1.5', className)}>
    <label className="text-[13px] font-semibold text-slate-900 dark:text-gray-100 flex items-center gap-1">
      {label}
      {optional && <span className="text-slate-500 dark:text-gray-400 font-normal">· Optional</span>}
      {required && <span className="text-red-500">*</span>}
    </label>
    {hint && <p className="text-[13px] text-slate-600 dark:text-gray-400">{hint}</p>}
    {children}
    {error && <p className="text-[11px] text-red-500 mt-1">{error}</p>}
  </div>
);

export default FormField;